/**
 * @file 恢复页面滚动位置
 * @author Yongning 2024-04-19
 */
import { useRouter } from 'next/router';
import { MEASURE_SIZE_CACHE } from '@/components/IvsList';

const PRE_SCROLLBAR_POSITION = 'page_position';

export type IUseResumeScrollPositionProps = {
  channelSlug?: string;
};

const useResumeScrollPosition = ({
  channelSlug,
}: IUseResumeScrollPositionProps = {}) => {
  const { pathname } = useRouter();

  const getCacheKey = (slug?: string) => `${PRE_SCROLLBAR_POSITION}${pathname}${slug || channelSlug}`;

  const savePageScrollTop = (top: number = 0) => {
    const key = getCacheKey();
    window[key] = top;
  };

  const getPageScrollTop = (slug?: string) => {
    const key = getCacheKey(slug);
    const scrollTop = typeof window !== 'undefined' && window[key] ? window[key] : 0;
    return scrollTop;
  };

  const MEASURE_SIZE_CACHE_KEY = `${MEASURE_SIZE_CACHE}${pathname}${channelSlug}`;

  const resetPageScrollTop = (top?: number) => {
    if (typeof top !== 'undefined') {
      savePageScrollTop(top);
    }
    // window[MEASURE_SIZE_CACHE_KEY] = undefined;
    // window[key] = 0;
  }

  return {
    // 获取当前缓存key
    getCacheKey,
    // 获取页面缓存滚动高度
    getPageScrollTop,
    // 缓存页面缓存滚动高度
    savePageScrollTop,
    // 重置页面缓存滚动高度
    resetPageScrollTop
  };
};

export default useResumeScrollPosition;
